import React from 'react'

import { splitDomain } from '../../utils/splitDomain'
import * as S from './DomainString.styled'

type DomainStringProps = {
  domain: string
}

export const DomainString = ({ domain }: DomainStringProps) => {
  const { mainDomain, tld } = splitDomain(domain)

  return (
    <>
      {mainDomain}
      {tld && <S.Suffix>.{tld}</S.Suffix>}
    </>
  )
}
